import refetchGoogleAds from "./refetchGoogleAds";

const handleRefetchAdvert = config => {
  refetchGoogleAds(config);
};

export default handleRefetchAdvert;
